export default __webpack_public_path__ + "static/media/current_m.5fa21b27.png";